/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    getDealerwareWebComponentsModule()
        .constant(
            'gridMapOpenContracts', {
                'reservations.id'                       : [ 'reservation_id', 'reservation_id_display' ],
                'reservations.ro_number'                : 'repair_order',
                'reservations.actual_pickup_date'       : 'actual_pickup_date',
                'reservations.confirmation_token'       : 'confirmation_token',
                'cars.license'                          : [ 'license', 'license_display' ],
                'cars.id'                               : 'car_id',
                'cars.stock_number'                     : [ 'stock_number', 'stock_number_display' ],
                'service_advisor_profiles.full_name'    : 'sap_full_name',
                'customers.full_name'                   : [ 'up_full_name', 'up_full_name_display' ],
                'customers.last_name'                   : 'up_last_name',
                'customers.first_name'                  : 'up_first_name',
                'customers.id'                          : 'up_user_id',
                'trims.year'                            : 'model_year',
                'trims.model'                           : 'model'
            }
        );

    export class OpenContractsController {
        public static $inject: string[] = [
            'DataUtils',
            'gridMapOpenContracts',
            '$dealerwareLookerService',
            '$dealerwareNotification',
            '$mobilityCompanyAuthentication',
            '$timeout',
            '$state',
            '$dealerwareInternationalizationData',
            'i18nService',
        ];

        private _dataUtils      : any;
        private _gridColumns    : any[];

        public collapsed        : boolean;
        public loading          : boolean = false;
        public error            : boolean = false;
        public gridMap          : any = { };
        public data             : any;
        public gridColumnDefs   : any;
        public labels           : any;
        public labelsUnformatted: {};

        constructor(
            public DataUtils                : any,
            public gridMapOpenContracts     : any,
            public $dealerwareLookerService : any,
            private $dealerwareNotification: any,
            public $auth                    : any,
            public $timeout                 : any,
            public $state                   : any,
            public $dealerwareInternationalizationData: any,
            public i18nService               : any
        ) {

            this.getLabels('dashboard');

            this.data = { };

            this._dataUtils = DataUtils.getInstance();
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                    _self.labels.columnHeaders = _self.$dealerwareInternationalizationData.formatLabelsByLanguage(localStorage.getItem('language'), _self.labels.columnHeaders);
                    _self.initColumns();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }

        public loadData() : void {

            var that = this;

            this.loading = true;
            this.gridMap = this.gridMapOpenContracts;
            this.gridColumnDefs = this._gridColumns;

            this.$dealerwareLookerService.loadOpenContracts(
                this.$auth.location.code
            ).then(function (response: any) {
                that.data = response;
            }).catch(function() {
                that.error = true;
            }).finally(function () {
                that.loading = false;
            });
        }

        public initColumns() : void {
            const that = this;

            this._gridColumns = [
                {
                    name            : 'Stock #',
                    displayName     : that.labels.columnHeaders.stock_number,
                    field           : 'stock_number_display',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function (value : any) {

                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id })} class="dashboard-open-contracts-stock">${value} </a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {

                        var valueA = that._dataUtils.isBlank(rowA.entity.stock_number) ? '' :
                            rowA.entity.stock_number.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.stock_number) ? '' :
                            rowB.entity.stock_number.toLowerCase();

                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name            : 'License Plate',
                    displayName     : that.labels.columnHeaders.license_plate,
                    field           : 'license_display',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function (value : any) {

                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.vehicles.details',
                            { vehicleId: this.car_id })} class="dashboard-open-contract-stock">${value}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {

                        var valueA = that._dataUtils.isBlank(rowA.entity.license) ? '' :
                            rowA.entity.license.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.license) ? '' :
                            rowB.entity.license.toLowerCase();

                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name: 'Vehicle Model',
                    displayName: that.labels.columnHeaders.vehicle_model,
                    field: 'model',
                    visible: true
                },
                {
                    name: 'Model Year',
                    displayName: that.labels.columnHeaders.model_year,
                    field: 'model_year',
                    visible: true
                },
                {
                    name            : 'Customer',
                    displayName     : that.labels.columnHeaders.customer,
                    field           : 'up_full_name_display',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function (value : any) {

                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.customers.details',
                            { customerId: this.up_user_id })} class="dashboard-open-contracts-customer">${this.up_last_name}, ${this.up_first_name}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {

                        var valueA = that._dataUtils.isBlank(rowA.entity.up_last_name) ? '' :
                            rowA.entity.up_last_name.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.up_last_name) ? '' :
                            rowB.entity.up_last_name.toLowerCase();

                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name            : 'Service Advisor',
                    displayName     : that.labels.columnHeaders.service_advisor,
                    field           : 'sap_full_name',
                    visible         : true
                },
                {
                    name            : 'Contract ID',
                    displayName     : that.labels.columnHeaders.contract_id,
                    field           : 'reservation_id_display',
                    visible         : true,
                    renderHtml      : true,
                    formatCallback  : function (value : any) {

                        return that._dataUtils.isBlank(value) ? '' :
                            `<a href=${that.$state.href('root.private.application.contracts.details',
                            { contractId: this.reservation_id })} class="dashboard-open-contracts-id">${this.confirmation_token}</a>`
                    },
                    sortingAlgorithm: function (a: any, b: any, rowA: any, rowB: any) {

                        var valueA = that._dataUtils.isBlank(rowA.entity.confirmation_token) ? '' :
                            rowA.entity.confirmation_token.toLowerCase();
                        var valueB = that._dataUtils.isBlank(rowB.entity.confirmation_token) ? '' :
                            rowB.entity.confirmation_token.toLowerCase();

                        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
                    }
                },
                {
                    name            : 'Repair Order',
                    displayName     : that.labels.columnHeaders.repair_order,
                    field           : 'repair_order',
                    visible         : true
                },
                {
                    name            : 'Days on Contract',
                    displayName     : that.labels.columnHeaders.days_on_contract,
                    field           : 'actual_pickup_date',
                    visible         : true,
                    formatCallback  : ( value: any ) => {
                        return moment().diff(moment(value), 'days');
                    }
                }
            ];

            this.$timeout(() => { that.loadData(); });
        }
    }

    getDealerwareWebComponentsModule().controller('OpenContractsController', OpenContractsController);

    export class OpenContractsDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'OpenContractsController';
        public controllerAs     : string    =   'openContractsController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/open_contracts/open_contracts_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareOpenContracts",() => new OpenContractsDirective());
}
